const createMinMediaQuery = (screenSize) => `only screen and (min-width: ${screenSize})`;

export default createMinMediaQuery;
